export const selector = '.global-header'

export default (
    el = null
) => {
    if (!el)
        return

    console.groupCollapsed('GlobalHeader')

    const heroEl = document.querySelector('.hero')

    if (!heroEl)
        return

    const observeCallback = (entries) => {
        el.setAttribute('data-scroll', !entries[0].isIntersecting
            ? 'stuck'
            : 'default')
        }

    const observer = new window.IntersectionObserver(observeCallback, {
        threshold: 0.1,
    })

    observer.observe(heroEl)

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                observer.unobserve(heroEl)
            })

    console.log(el)

    console.groupEnd()

    return el
}
